import React, { Component } from 'react';
import './App.css';
//components
import Login from './components/Login';
import Logout from './components/Logout';
import Homepage from './container/Homepage';
import IoT from './container/IoT';
//router
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from 'react-router-dom'
//config
import config from './config';
//store
import events from './store/events';
import cocorobo from './store/cocorobo';
import { observer } from 'mobx-react';


@observer
class App extends Component {
  componentDidMount() {
    // document.domain = 'cocorobo.hk';
  }
  render() {
    console.log(events, '------------------------------')
    return (
      <Router basename='/cloud'>
        <div className="App">
          <Route exact path='/' component={Homepage} />
          <Route exact path='/login' component={Login} />
          <Route path='/iot' component={IoT} />
          <Route exact path='/logout' component={Logout} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js